import StudentList from './StudentList.jsx';
export default StudentList;